import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["flag", "message"]
  static values = { url: String }

  async check(event) {
    const customerId = event.target.value

    console.log(customerId);

    if (!customerId) {
      this.hideFlag()
      return
    }

    try {
      const response = await fetch(`/customers/${customerId}/dues_check`, {
        headers: { Accept: "application/json" }
      })

      if (!response.ok) {
        this.hideFlag()
        return
      }

      const data = await response.json()

      console.log(data);

      if (data.has_dues) {
        this.messageTarget.innerHTML = `
          Customer has outstanding dues of
          <strong>${data.amount}</strong>
          across <strong>${data.count}</strong> sale(s).
        `
        this.flagTarget.classList.remove("d-none")
      } else {
        this.hideFlag()
      }
    } catch (_error) {
      this.hideFlag()
    }
  }

  hideFlag() {
    if (this.hasMessageTarget) {
      this.messageTarget.innerHTML = ""
    }

    if (this.hasFlagTarget) {
      this.flagTarget.classList.add("d-none")
    }
  }
}
